module.exports = __webpack_public_path__ + "media/images/sp/specials/fair/icon_more-b3b6a0839d51e4bd35183153c4b1803c.svg";